export default "__VITE_ASSET__63651340__"